import homepage from './homepage';
import breachedPasswords from './breached-passwords';
import guardian from './guardian';
import howItWorks from './how-it-works';
import learn from './learn';
// import pricing from './pricing';
import whyAuth0 from './why-auth0';

const pages = [
  homepage,
  breachedPasswords,
  guardian,
  howItWorks,
  learn,
  // pricing,
  whyAuth0
];

export default function register() {
  pages.forEach(page => page());
}



// WEBPACK FOOTER //
// ./src/pages/jp/client.js